import {PlotlyHTMLElement} from "plotly.js";
import {toBlob} from "html-to-image";

export const copyChartToClipBoard = (gd: PlotlyHTMLElement, ev: MouseEvent) => {
    const el = gd.firstChild?.firstChild as HTMLDivElement;
    const modebar = el.getElementsByClassName("modebar-container")[0];

    el.removeChild(modebar)

    toBlob(el)
        .then(function (blob) {
            navigator.clipboard.write([
                new ClipboardItem({
                    'image/png': blob!
                })
            ]).then(r => PF('globalGrowl').renderMessage(
                {
                    "summary": "Clipboard",
                    "detail": "Chart copied to clipboard",
                    "severity": "info",
                })
            );
        })
        .catch(function (error) {
            PF('globalGrowl').renderMessage(
                {
                    "summary": "Clipboard",
                    "detail": "This feature may not be supported on you browser",
                    "severity": "error",
                })
            console.error('Something went wrong!', error);
        })
        .finally(() => {
            el.appendChild(modebar);
        });
}